"use client";

/** Per-screen "Show me around" replay button. Pairs with `useAutoTour`:
 * pass its `replay` here so manual replays always run regardless of seen-state. */
export function TourButton({ onClick, label = "Show me around" }: { onClick: () => void; label?: string }) {
    return (
        <button
            onClick={onClick}
            title={label}
            className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-[#007a8a] hover:underline"
        >
            <span className="material-symbols-outlined text-[14px]">explore</span>
            {label}
        </button>
    );
}
